import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import {
    AuthorizationGuard,
    CustomPreloadStrategy,
    LsqBrowserNotSupportedPageComponent,
    LsqHealthComponent,
    LsqLogoutComponent,
    LsqNotFoundComponent,
    NotAuthorizedGuard,
    Routes
} from '@lsq-frontend/common-ui';
import { FastTrackRouteQueryParams } from '@lsq-frontend/fasttrack-shared/app-constants';
import { environment, loadMFE } from '@lsq-frontend/fasttrack-shared/environment';
import { EulaGuard } from '@lsq-frontend/fasttrack-shared/features/eula-service';
import { rootAtlas } from '@lsq-frontend/fasttrack-shared/routing-atlas';
import { EulaPageComponent } from './login/eula/eula-page.component';
import { LoginPageComponent } from './login/login-page.component';

export const appRoutes: Routes = [
    {
        path: rootAtlas.LOGIN.path,
        component: LoginPageComponent,
        canActivate: [NotAuthorizedGuard],
        data: {
            title: rootAtlas.LOGIN.title,
            guardBypassQueryParams: [
                FastTrackRouteQueryParams.VerificationCode,
                FastTrackRouteQueryParams.MultiFactorAuthenticationSetup
            ]
        }
    },
    {
        path: rootAtlas.EULA.path,
        component: EulaPageComponent,
        canActivate: [AuthorizationGuard, EulaGuard],
        data: {
            title: rootAtlas.EULA.title
        }
    },
    {
        path: rootAtlas.HEALTH.path,
        component: LsqHealthComponent,
        data: {
            title: rootAtlas.HEALTH.title
        }
    },
    {
        path: rootAtlas.HEALTH_ALT.path,
        component: LsqHealthComponent,
        data: {
            title: rootAtlas.HEALTH_ALT.title
        }
    },
    {
        path: rootAtlas.NOT_FOUND.path,
        component: LsqNotFoundComponent,
        data: {
            title: rootAtlas.NOT_FOUND.title
        }
    },
    {
        path: rootAtlas.BROWSER_NOT_SUPPORTED.path,
        component: LsqBrowserNotSupportedPageComponent,
        data: {
            title: rootAtlas.BROWSER_NOT_SUPPORTED.title
        }
    },
    {
        path: rootAtlas.LOGOUT.path,
        component: LsqLogoutComponent,
        data: {
            title: rootAtlas.LOGOUT.title
        }
    },
    ...(!environment.isDemo
        ? [
              {
                  path: rootAtlas.AR_APPLICATION.path,
                  data: { skipPreload: true },
                  loadChildren: loadMFE('arApp')
              }
          ]
        : []),
    {
        path: '',
        loadChildren: loadMFE('monolith')
    }
];

@NgModule({
    imports: [
        RouterModule.forRoot(appRoutes, {
            preloadingStrategy: CustomPreloadStrategy,
            anchorScrolling: 'enabled',
            relativeLinkResolution: 'legacy',
            scrollPositionRestoration: 'enabled'
        })
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {}
